import * as swcHelpers from '@swc/helpers';
import { isPresent, isDefined } from '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { getSolutionsProductFeatures } from '../utils/product-feature-mappers/get-solutions-product-features.js';
import { mapServerToSolutionsSpecifications } from '../specification-mappers/map-server-to-solutions-specifications.js';
import { mapServerToVariantBase } from './map-server-to-variant-base.js';

const mapServerToSolutionsVariant = (serverProduct, slug, locale)=>{
    const { variants: serverVariants  } = serverProduct;
    if (!serverVariants || !serverVariants.length) {
        return;
    }
    const clientVariants = serverVariants.map((serverVariant)=>{
        const variantBase = mapServerToVariantBase(serverVariant, serverProduct, slug, locale);
        if (!variantBase) return;
        const { contactLensCareType , targetUsers , convenience , keyInstructions , subscriptionIntervals , volume: volumeValue , volumeUnit ,  } = serverVariant.variantTypeDetails;
        const volume = `${volumeValue}${volumeUnit}`;
        const productFeatures = getSolutionsProductFeatures(serverVariant.variantTypeDetails);
        const specifications = mapServerToSolutionsSpecifications(serverVariant, serverProduct.brand);
        const detailsList = [
            targetUsers,
            convenience,
            keyInstructions
        ].filter(isPresent).filter((item)=>item !== ''
        );
        const solution = swcHelpers.objectSpread({}, variantBase, {
            variantType: 'solutions',
            facets: {
                volume
            },
            productFeatures,
            specifications,
            detailsList,
            contactLensCareType: contactLensCareType !== null && contactLensCareType !== void 0 ? contactLensCareType : undefined,
            availableSubscriptionIntervals: subscriptionIntervals
        });
        return solution;
    });
    return clientVariants.filter(isDefined);
};

export { mapServerToSolutionsVariant };
//# sourceMappingURL=map-server-to-solutions-variant.js.map
